import {
  any, boolean, date, nullable,
  number, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PrivateTicketMask = {
  showId: string,
  collaborators: any,

  // Guest data
  owner: string,
  isRedeemed: boolean,
  redeemedAt: date | nullable,
  guestName: string,
  guestEmail: string,
  description: string | nullable,

  // Purchase data
  purchaserEmail: string,
  purchaserName: string,
  purchaseTime: date,
  canonicalOrderId: string | nullable,
  stripeSKU: string,
  recoupAmount: number,
  stripeOrderType: string,
  stripeOrderId: string,
  purchaser: string,
  compiledAddress: string,
  latLng: any,
  isAnonymous: boolean,

  // Zoom/streaming fields
  pendingRedemption: boolean,
  shareContact: boolean,
  registrantId: string | nullable,
  registeredAt: date | nullable,
  registrantEmail: string | nullable,
  streamJoinUrl: string | nullable,
  replayJoinUrl: string | nullable,
  replayJoinedAt: date | nullable,

  isBulkImport: boolean,

  // Series pass
  showGroupId: string,
  productGroupId: string,
  relatedTicketId: string,
};
